import * as Utils from "../libraries/utils";
import appConfig from "../appconfig";
import {canBePickedUp, evaluateCustomerType, getIconsImageUrl} from "../libraries/utils";
import ProductSelection from "../domains2/orders/ProductSelection";
import OrderHelperObject from "../domains2/orders/OrderHelperObject";
import {store} from "../store";
const TimeBox = appConfig.timeBoxImpl.timebox;

const CategoryHelper = {
	findCategory: (self, productId) => {
		const shopId = self.$store.getters.globalSelectedShop.id;
		const productCatalog = self.$store.getters.productCatalog;
		const categories = Utils.getCategoriesByShopId(
			shopId,
			productCatalog
		);
		return categories.find((cat) => {
			return (
				cat.elements.find((element) => {
					if (element.objType === "GridBlockElement") {
						return (
							element.items.find((product) => product.id === productId) !== undefined
						);
					} else if (element.props && element.props.products) {
						return (
							element.props.products.find((product) => product === productId) !== undefined
						);
					} else {
						return false;
					}
				}) !== undefined
			);
		});
	},
	getFilteredAndSortedCategories(productCatalog, globalSelectedShop, cachedPickupRules) {
		const categories = [...productCatalog.getCategories()]
			.filter(cat => {
				if (Array.isArray(cat.isSpecificForShops)) {
					return cat.isSpecificForShops.includes(globalSelectedShop.id) && cat.channels.includes(appConfig.channelAlias());
				}
				return cat.channels?.includes(appConfig.channelAlias()) || [];
			})
			.sort((p1, p2) => parseInt(p1.menuPosition) - parseInt(p2.menuPosition));
		categories.forEach(category => {
			if (cachedPickupRules.length && globalSelectedShop) {
				category.elements.forEach((element, i) => {
					category.elements[i].props.products = element.props.products.filter(productId => {
						return canBePickedUp(
							productCatalog.getProduct(productId, true),
							productCatalog,
							cachedPickupRules,
							globalSelectedShop.id
						);
					});
				});
			}
		});
		return categories;
	},
	getFilteredCategories({
		hideToolbar,
		isReorderState,
		isLoggedIn,
		getFavouriteProducts,
		hiddenItems,
		getIconUrl,
		fetchedProductCatalog = null
	}) {
		if (hideToolbar) {
			return [];
		}
		const productCatalog = fetchedProductCatalog || store.getters.productCatalog;
		const globalSelectedShop = store.getters.globalSelectedShop;
		const cachedPickupRules = store.getters.cachedPickupRules;
		const customerType = evaluateCustomerType();
		let filteredCategories = [
			...CategoryHelper.getFilteredAndSortedCategories(
				productCatalog,
				globalSelectedShop,
				cachedPickupRules
			)
		].filter(cat => {
			const availableToCustomerType = !cat.customerTypes
				|| !cat.customerTypes.length
				|| cat.customerTypes.includes(customerType);
			const hideByABTest = store.getters.aBTestsHiddenCatalogExtId
				&& cat.extId === store.getters.aBTestsHiddenCatalogExtId;
			return availableToCustomerType && !hideByABTest;
		});
		if(
			store.getters.featureToggles.enableRecommendationsCatalogPage
			&& globalSelectedShop
			&& globalSelectedShop.shopOptions.recommendationEngineEnabledCatalog
			&& isLoggedIn
			&& isReorderState
		) {
			const reorderingCategoryIndex = filteredCategories.findIndex(cat =>
				cat.isRecommendationsCatalogPage &&
				cat.channels.includes(appConfig.channelAlias())
			);
			if (
				reorderingCategoryIndex > -1
			) {
				filteredCategories[reorderingCategoryIndex].iconUrl = "images/icons/recommendations-page.svg";
				filteredCategories[reorderingCategoryIndex].inactiveIconUrl = "images/icons/recommendations-page-inactive.svg";
				if(!filteredCategories[reorderingCategoryIndex].elements[0]) {
					filteredCategories[reorderingCategoryIndex].elements[0] = {props: {products: []}};
				}
				if(!filteredCategories[reorderingCategoryIndex].elements[1]) {
					filteredCategories[reorderingCategoryIndex].elements[1] = {props: {products: []}};
				}
				filteredCategories[reorderingCategoryIndex].elements[0].props.products = this.recommendedProductsForCatalogPage;
				filteredCategories[reorderingCategoryIndex].elements[1].props.products = this.historyProducts;
			}
		}

		if (isLoggedIn && store.getters.featureToggles.favoriteProducts) {
			const currentUserFavouriteProducts = typeof getFavouriteProducts === "function"
				? getFavouriteProducts()
				: getFavouriteProducts;
			const favouriteProductsCategoryIndex = filteredCategories.findIndex(cat =>
				cat.isFavoriteProductsCategory &&
				cat.channels.includes(appConfig.channelAlias())
			);
			if (
				currentUserFavouriteProducts &&
				currentUserFavouriteProducts.length &&
				favouriteProductsCategoryIndex > -1
			) {
				filteredCategories[favouriteProductsCategoryIndex].iconUrl = "images/icons/web-favorite.svg";
				filteredCategories[favouriteProductsCategoryIndex].inactiveIconUrl = "images/icons/web-favorite-inactive.svg";
				filteredCategories[favouriteProductsCategoryIndex].elements[0].props.products =
					currentUserFavouriteProducts
						? currentUserFavouriteProducts.map(p => p.productId)
						: filteredCategories[favouriteProductsCategoryIndex].elements[0].props.products;
			} else if(favouriteProductsCategoryIndex > -1) {
				filteredCategories[favouriteProductsCategoryIndex].elements[0].props.products = [];
			}
		} else {
			filteredCategories = filteredCategories.filter(cat => !cat.isFavoriteProductsCategory);
		}
		return filteredCategories
			.sort((p1, p2) => parseInt(p1.menuPosition) - parseInt(p2.menuPosition))
			.map(category => {
				category.isSelected = false;
				category.fullIconUrl = getIconUrl(category);
				return category;
			})
			.filter(category => {
				return category.elements.some(element => {
					// shortcut for RECOMMENDATIONS subcategory, it should not be filtered out here if there are no products
					if(element.props.subCategoryType && element.props.subCategoryType === "RECOMMENDATIONS") {
						return true;
					}
					return element.props && element.props.products && element.props.products.some(productId => {
						if (typeof productId !== "string") {
							return false;
						}
						const boxDate = TimeBox.realNow();
						const productSelections = [ProductSelection.createFromProduct(productCatalog.getProduct(productId, true))];
						return OrderHelperObject.canBePickedUp({
							boxDate,
							productSelections,
							tenantData: appConfig.tenantConfig,
							pickupDateTimeRules: cachedPickupRules,
							shopId: store.getters.getShopData.id,
							includeDisabled: true,
							productCatalog: productCatalog,
							hiddenItems: hiddenItems
						});
					});
				});
			});
	},
	getIconUrl(category) {
		if (store.getters.featureToggles.enableScrollableTabsMenuNavigationMobile && (appConfig.mobile.isMobileApp() || appConfig.channelAlias() === "mobileBrowser")) {
			return getIconsImageUrl(category.mobileIconUrl || category.inactiveIconUrl);
		}
		const iconUrl = category.isSelected ? category.iconUrl : (category.inactiveIconUrl || category.iconUrl);
		return getIconsImageUrl(iconUrl);
	}
};

export default CategoryHelper;
